import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import React from 'react';
import api from '@common/utils/api';
import ProductBoutiqueStore from './ProductBoutiqueStore';
const ProductBoutiqueTabEurope = (props) => {
    const [countries, setCountries] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    React.useEffect(() => {
        if (!props.pid) {
            setCountries([]);
            setLoading(false);
        }
        else {
            setLoading(true);
            api.checkBoutiqueAvailability(props.pid, props.country, true).then((data) => {
                let countrygroups = new Map();
                if (data) {
                    data.stores.forEach((s) => {
                        if (s.countryCode) {
                            let cg = countrygroups.get(s.countryCode.value);
                            if (!cg) {
                                countrygroups.set(s.countryCode.value, {
                                    label: s.countryCode.displayValue,
                                    stores: [s],
                                });
                            }
                            else {
                                cg.stores.push(s);
                            }
                        }
                    });
                    setCountries(Array.from(countrygroups.values()).sort((a, b) => {
                        return a.label.localeCompare(b.label);
                    }));
                    setLoading(false);
                }
                else {
                    setLoading(false);
                }
            });
        }
    }, [props.pid, props.country]);
    if (loading) {
        return React.createElement(React.Fragment, null);
    }
    if (countries.length == 0) {
        return props.noResults;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Accordion, null, countries.map((c) => {
            var _a;
            return (React.createElement(AccordionItem, { key: c.label, title: React.createElement("span", null,
                    c.label,
                    React.createElement("sup", null, (_a = c.stores) === null || _a === void 0 ? void 0 : _a.length)), accordionId: c.label }, c.stores.map((fs, idx) => (React.createElement(ProductBoutiqueStore, { key: fs.ID, index: idx + 1, store: fs, onReservePress: () => props.onStoreSelect(fs) })))));
        }))));
};
export default ProductBoutiqueTabEurope;
